module.exports = {
	"ha": "vcha",
	"id": 5.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 67.94258373205741,
						"dataLabels": {
							"enabled": true,
							"format": "142",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.76555023923444,
						"dataLabels": {
							"enabled": true,
							"format": "127",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 58.3732057416268,
						"dataLabels": {
							"enabled": true,
							"format": "122",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.63157894736842,
						"dataLabels": {
							"enabled": true,
							"format": "110",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 47.84688995215311,
						"dataLabels": {
							"enabled": true,
							"format": "100",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.44744744744744,
						"dataLabels": {
							"enabled": true,
							"format": "649",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.48348348348348,
						"dataLabels": {
							"enabled": true,
							"format": "556",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.52852852852853,
						"dataLabels": {
							"enabled": true,
							"format": "523",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.81981981981981,
						"dataLabels": {
							"enabled": true,
							"format": "465",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.36036036036037,
						"dataLabels": {
							"enabled": true,
							"format": "402",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.87037037037038,
						"dataLabels": {
							"enabled": true,
							"format": "1057",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.81481481481481,
						"dataLabels": {
							"enabled": true,
							"format": "916",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.46296296296296,
						"dataLabels": {
							"enabled": true,
							"format": "869",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.14814814814815,
						"dataLabels": {
							"enabled": true,
							"format": "790",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 61.38888888888889,
						"dataLabels": {
							"enabled": true,
							"format": "663",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.87410440122825,
						"dataLabels": {
							"enabled": true,
							"format": "2898",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.58103036506311,
						"dataLabels": {
							"enabled": true,
							"format": "2567",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.9986352780621,
						"dataLabels": {
							"enabled": true,
							"format": "2462",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.93858751279427,
						"dataLabels": {
							"enabled": true,
							"format": "2343",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.52200614124871,
						"dataLabels": {
							"enabled": true,
							"format": "2067",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -32.057416267942585,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.563380281690138,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.937007874015752,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.836065573770492,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.552552552552556,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.329738058551623,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.935251798561147,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.089866156787764,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.548387096774196,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.1296296296296258,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.33964049195837,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.131004366812231,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.075949367088604,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.1258955987717534,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.421670117322291,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.090377873003503,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.833468724614132,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.779769526248396,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=209"
			},
			{
				"x": 9,
				"text": "30–39<br>n=666"
			},
			{
				"x": 15,
				"text": "40–49<br>n=1080"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=2931"
			}
		],
		"dataTable": {
			"< 30": [
				209,
				142,
				127,
				122,
				110,
				100
			],
			"30–39": [
				666,
				649,
				556,
				523,
				465,
				402
			],
			"40–49": [
				1080,
				1057,
				916,
				869,
				790,
				663
			],
			"≥ 50": [
				2931,
				2898,
				2567,
				2462,
				2343,
				2067
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_3.json
// module id = 303
// module chunks = 0